import { render, staticRenderFns } from "./ProofOfConcept.vue?vue&type=template&id=53f1a713&"
import script from "./ProofOfConcept.vue?vue&type=script&lang=ts&"
export * from "./ProofOfConcept.vue?vue&type=script&lang=ts&"
import style0 from "./ProofOfConcept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports